<div class="main-content">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-md-12">
          <span class="pull-left py-3">
            <h2 class="text-purple-manax m-0 pl-3 title-section">Costos</h2>
            <p class="text-purple-manax pl-3 subtitle-section">Costos que se incluirán en tus Servicios y/o Proyectos.
            </p>
          </span>
          <span class="pull-right py-3 pr-3">
            <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openNewExpenseModal()">
              <i class="material-icons">add</i> Nuevo Costo
            </button>
          </span>
          <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortExpenses($event)" stickyHeader
            stickyFooter>
  
            <thead class="text-manax">
              <tr>
  
                <!-- All -->
                <!-- <th class="p-0 pl-2">
                  <div class="form-check m-0 mx-2">
                    <label class="form-check-label">
                      <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                        [checked]="selection.all">
                      <span class="form-check-sign">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </th> -->
  
                <!-- PC -->
                <th class="d-none d-md-table-cell align-top" mat-sort-header="name"
                  style="height: 70px; position: relative;">
                  Nombre<br>
                  <input type="text" class="filter small" [(ngModel)]="filter.filters.name" (ngModelChange)="lazySearch()"
                    (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                    style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
                </th>
                <th class="d-none d-md-table-cell align-top" mat-sort-header="name"
                  style="height: 70px; position: relative;">
                  Descripción<br>
                  <input type="text" class="filter small" [(ngModel)]="filter.filters.description"
                    (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()"
                    style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
                </th>
                <th class="d-none d-md-table-cell align-top" mat-sort-header="cost">
                  Costo {{curr}}
                </th>
                <th class="d-none d-md-table-cell align-top" width="1%"
                  style="height: 65px; position: relative; max-width: 1000px;" mat-sort-header="isDeleted">
                  Estado<br>
                  <select class="filter small" [(ngModel)]="filter.filters.isDeleted" (ngModelChange)="getExpenses(true)"
                    (click)="$event.stopPropagation()"
                    style="max-width: 1000px; position: absolute; top: 27px; left: 0px;">
                    <option [ngValue]="false"> activo </option> <!-- isDeleted: false -->
                    <option [ngValue]="true"> inactivo </option> <!-- isDeleted: true -->
                    <option [ngValue]="undefined"> todos </option>
                  </select>
                </th>
  
                <!-- Mobile -->
                <th class="d-table-cell d-md-none">
                  Orden por: <span class="ml-2">{{sortOptions[filter.sort || ''] || 'ninguno'}}</span>
                  <span class="text-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
                </th>
  
                <!-- All -->
                <th class="td-actions text-right p-0">
                  <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                    [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <i class="material-icons">more_vert</i>
                  </button>
                  <mat-menu #menu="matMenu">
  
                    <!-- sort order -->
                    <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                      <span>Orden</span>
                    </button>
  
                    <button mat-menu-item (click)="clearFilter()">
                      <span>Limpiar Filtros</span>
                    </button>
  
                  </mat-menu>
  
                  <mat-menu #order="matMenu">
                    <ng-container *ngFor="let key of sortOptionsKeys">
                      <button mat-menu-item (click)="sortExpenses(key)">
                        <span>{{sortOptions[key]}}</span>
                      </button>
                    </ng-container>
                    <button mat-menu-item (click)="sortExpenses('')">
                      <span>Sin Ordenar</span>
                    </button>
                  </mat-menu>
                </th>
              </tr>
            </thead>
  
            <tbody>
              <tr *ngFor="let expense of expenses" [class.text-danger]="expense.isDeleted" class='cursor-pointer'
                (click)="openExpenseModal(expense, true)">
  
                <!-- All -->
                <!-- <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                  <div class="form-check m-0 mx-2">
                    <label class="form-check-label">
                      <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(expense._id)"
                        [checked]="selection.all || selection[expense._id || '']">
                      <span class="form-check-sign">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </td> -->
  
                <!-- PC -->
                <td class="d-none d-md-table-cell">{{expense.name}}</td>
                <td class="d-none d-md-table-cell">{{expense.description}}</td>
                <td class="d-none d-md-table-cell">{{expense.amount}}</td>
                <td class="d-none d-md-table-cell">
                  <span *ngIf="!expense.isDeleted">activa</span>
                  <span *ngIf="expense.isDeleted">borrada</span>
                </td>
  
                <!-- Mobile -->
                <td class="d-table-cell d-md-none" style="line-height: 14px;">
                  <b>{{expense.name}}</b><br>
                  <b>{{expense.description}}</b><br>
                  <span style="line-height: 15px;" class="small">
                    <!--{{amount}}--> {{expense.amount}}<br>
                    <span class="pull-right" *ngIf="expense.isDeleted">borrada</span>
                  </span>
                </td>
  
                <!-- All -->
                <td class="td-actions text-right p-0">
                  <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                    [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <i class="material-icons">more_vert</i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openExpenseModal(expense, true)">
                      <span>Abrir</span>
                    </button>
                    <button mat-menu-item (click)="openExpenseModal(expense)">
                      <span>Modificar</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteExpenseConfirm(expense, true)" *ngIf="isDev">
                      <span>Hard Delete</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteExpenseConfirm(expense)" *ngIf="!expense.isDeleted">
                      <span>Eliminar</span>
                    </button>
                    <button mat-menu-item (click)="openRestoreExpenseConfirm(expense)" *ngIf="expense.isDeleted">
                      <span>Restaurar</span>
                    </button>
                  </mat-menu>
                </td>
              </tr>
  
              <!-- All -->
              <tr *ngIf="thereAreMore && !loading">
                <td colspan="10">
                  <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                    mas</button>
                </td>
              </tr>
              <tr *ngIf="loading">
                <td colspan="10" class="text-center">
                  <div class="d-flex justify-content-center" >
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot class="text-purple-manax">
              <tr *ngIf="!loading">
                <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ expenses.length }} costos</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>